// extracted by mini-css-extract-plugin
export var closeButton = "_ql-2";
export var closeButtonIcon = "_ql-3";
export var lightboxContent = "_ql-1";
export var lightboxOverlay = "_ql-0";